// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import {
    GridColDef,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
    GridExpandMoreIcon,
} from "@mui/x-data-grid";
import { Button, Loading } from "../../atoms";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { downloadExcel } from "../../../util/downloadExcel";
import {
    useListMerchantGroupedTransactions
} from "../../../hooks";

import {
    FormControl,
    useTheme,
    useMediaQuery,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
    Table,
    DateTimePickerControl
} from "../../molecules";
import { zodResolver } from "@hookform/resolvers/zod";
import dayjs from "dayjs";
import { MerchantTotalTransactionValuesType, merchantTotalTransactionFormSchema, merchantTotalTransactionInitialValues } from "./_formTypes";
import { convertTableFiltersToRequestFilter } from '../../../util/requestFilterHelper';

export const MerchantTotalTransactionsReportFilter = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [queryOptions, setQueryOptions] = React.useState({});
    const [isPageLoading, setIsPageLoading] = useState(true);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25
    });

    const { mutate: merchantGroupedTransactions, isLoading: isMerchantGroupedTransactionLoading } = useListMerchantGroupedTransactions();

    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantTotalTransactionValuesType>({
            resolver: zodResolver(merchantTotalTransactionFormSchema),
            defaultValues: merchantTotalTransactionInitialValues,
        });

    useEffect(() => {
        setValue("startDate", dayjs().add(-1, "day"));
        setValue("endDate", dayjs());
    }, [setValue]);

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const [showTable, setShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isFilterAccordionExpanded, setIsFilterAccordionExpanded] = useState(true);
    const [dynamicFilters, setDyanamicFilters] = useState([]);

    const onExport = () => {
        function fieldValue(data) {
            return data.map((item) => {
                return {
                    "Üye İşyeri No": item?.merchantId,
                    "Üye İşyeri Adı": item?.companyTitle,
                    "Satış Portföy": item?.userPortfolioFullName,
                    "İl": item?.city,
                    "İlçe": item?.district,
                    "Sözleşme Tarihi": item?.dateOfContract ? dayjs(item.dateOfContract).format('DD.MM.YYYY') : "",
                    "TL İşlem Sayısı": item?.tlTransactionsCount,
                    // "TL İşlem Toplamı": item?.tlTransactionsTotalAmount ? `${item.tlTransactionsTotalAmount}` : "",
                    // "TL İşlem Toplamı": item?.tlTransactionsTotalAmount ? parseFloat(item.tlTransactionsTotalAmount).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "",
                    "TL İşlem Toplamı": item?.tlTransactionsTotalAmount,
                    "USD İşlem Sayısı": item?.usdTransactionsCount,
                    "USD İşlem Toplamı": item?.usdTransactionsTotalAmount ? `${parseFloat(item.usdTransactionsTotalAmount).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "",
                    "EUR İşlem Sayısı": item?.eurTransactionsCount,
                    "EUR İşlem Toplamı": item?.eurTransactionsTotalAmount ? `${parseFloat(item.eurTransactionsTotalAmount).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "",
                    "Toplam İşlem Sayısı": item?.totalTransactionsCount,
                    "İlk İşlem Tarihi": item?.firstTransactionDate ? dayjs(item.firstTransactionDate).format('DD.MM.YYYY') : "",
                    "SanalPOS İşlem Sayısı": item?.vPosTransactionsCount,
                    "Benim Faturam İşlem Sayısı": item?.benimFaturamTransactionsCount,
                    "CepPOS İşlem Sayısı": item?.cepPosTransactionsCount,
                    "SanalPOS API İşlem Sayısı": item?.sanalPosAPITransactionsCount,
                };
            });

        }

        console.log(getValues("startDate"))
        console.log(getValues("endDate"))

        merchantGroupedTransactions({
            page: paginationModel.page,
            size: 999999,
            startDate: dayjs(getValues("startDate")).format("YYYY-MM-DD"),
            endDate: dayjs(getValues("endDate")).format("YYYY-MM-DD"),
            filters: [
                ...dynamicFilters
            ] // Handle dynamic filters
        }, {
            onSuccess: (result) => {
                const refactoredData = fieldValue(result?.data?.result);
                downloadExcel(refactoredData || [], "İşyeri başarılı işlemler", null);
                return;
            },
            onError: (result) => {
            }
        })
    }

    const getMerchantGroupedTransactions = (data: MerchantTotalTransactionValuesType) => {
        setTableData(undefined);
        setIsPageLoading(true);
        setIsFormSubmitted(true);

        merchantGroupedTransactions({
            page: paginationModel.page,
            size: paginationModel.pageSize,
            startDate: data?.startDate
                ? dayjs(data.startDate).format("YYYY-MM-DD 00:00:00")
                : "",
            endDate: data?.endDate
                ? dayjs(data.endDate).format("YYYY-MM-DD 23:59:59")
                : "",
            filters: [
                ...dynamicFilters
            ] // Handle dynamic filters
        }, {
            onSuccess: (result) => {
                setTableData(result?.data);
                setIsFilterAccordionExpanded(false);
                setShowTable(true);
                setIsPageLoading(false);
            },
            onError: (result) => {

            }
        })
    }

    useEffect(() => {

        if (!isFormSubmitted) return;

        getMerchantGroupedTransactions();
    }, [paginationModel.page, paginationModel.pageSize, queryOptions])

    const getQueryParams = (filters) => {
        const queryParams = {};

        for (let key in filters) {
            if (filters[key]?.toString()?.length >= 1) {
                queryParams[key] = filters[key];
            }
        }

        return queryParams;
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            localStorage.removeItem('merchantGroupedTransactions')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key, value) => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }


        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
        //     return;
        // }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDyanamicFilters(convertTableFiltersToRequestFilter(tableFilters, columns));
            localStorage.setItem('merchantGroupedTransactions', JSON.stringify(queryParams));
        }

        previousQueryParams.current = queryParams;
        setPaginationModel({
            page: 0,
            pageSize: paginationModel.pageSize
        });
    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    const previousQueryParams = React.useRef({});


    const columns: GridColDef[] = useMemo(() => {
        return [
            { field: "merchantId", headerName: "Üye İşyeri No", width: 120 },
            { field: "companyTitle", headerName: "Üye İşyeri Adı", width: 350 },
            {
                field: "merchantStatus", headerName: "Üye İşyeri Durumu", width: 150,
                renderCell: (params) => params.value == "PASSIVE" ? "Pasif" : (params.value == "BLOCKED" ? "Blokeli" : "Aktif")
            },
            { field: "userPortfolioFullName", headerName: "Satış Portföy", width: 200 },
            { field: "city", headerName: "İl", width: 150 },
            { field: "district", headerName: "İlçe", width: 150 },
            { field: "dateOfContract", headerName: "Sözleşme Tarihi", width: 120, renderCell: (params) => { return params.value ? dayjs(params.value).format('DD.MM.YYYY') : "-" }, filterable: false },
            { field: "tlTransactionsCount", headerName: "TL İşlem Sayısı", width: 120 },
            {
                field: "tlTransactionsTotalAmount", headerName: "TL İşlem Toplamı", type: 'decimal', width: 120, valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return ""
                    }
                    return `${params.value} TL`;
                },
                filterable: false
            },
            { field: "usdTransactionsCount", headerName: "USD İşlem Sayısı", width: 120, filterable: false },
            {
                field: "usdTransactionsTotalAmount", headerName: "USD İşlem Toplamı", width: 120, valueFormatter: (params: GridValueFormatterParams<number>) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${parseFloat(params.value).toLocaleString("tr-TR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} USD`;
                },
                filterable: false
            },
            { field: "eurTransactionsCount", headerName: "EUR İşlem Sayısı", width: 120, filterable: false },
            {
                field: "eurTransactionsTotalAmount", headerName: "EUR İşlem Toplamı", width: 120, renderCell: (params) => {
                    if (params.value == null) {
                        return "";
                    }
                    return `${parseFloat(params.value).toLocaleString("tr-TR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} EUR`;
                },
                filterable: false
            },
            { field: "totalTransactionsCount", headerName: "Toplam İşlem Sayısı", width: 120, filterable: false },
            { field: "firstTransactionDate", headerName: "İlk İşlem Tarihi", width: 120, renderCell: (params) => { return params.value ? dayjs(params.value).format('DD.MM.YYYY') : '-' }, filterable: false },
            { field: "vPosTransactionsCount", headerName: "SanalPOS İşlem Sayısı", width: 120, filterable: false },
            { field: "benimFaturamTransactionsCount", headerName: "Benim Faturam İşlem Sayısı", width: 120, filterable: false },
            { field: "cepPosTransactionsCount", headerName: "CepPOS İşlem Sayısı", width: 120, filterable: false },
            { field: "sanalPosAPITransactionsCount", headerName: "SanalPOS API İşlem Sayısı", width: 120, filterable: false },
        ];
    });

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    const isLoading = isMerchantGroupedTransactionLoading;

    return (
        <>
            {isLoading && <Loading />}
            <Stack flex={1} justifyContent={'space-between'}>
                <Stack flex={1} p={2}>
                    <BaseFilterTableWithAccordion summary="İşyeri Başarılı İşlemler" isExpanded={isFilterAccordionExpanded} setExpanded={setIsFilterAccordionExpanded} setTableVisibility={setShowTable}
                        child={<Stack spacing={4}>
                            <Stack spacing={3} direction={isDesktop ? 'row' : 'column'} width={isDesktop ? '100%' : 'auto'} maxWidth={1308}>
                                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                    <DateTimePickerControl
                                        sx={{ flex: 1 }}
                                        id="startDate"
                                        control={control}
                                        label="Başlangıç Tarihi"
                                        defaultValue={dayjs().add(-1, "day")}
                                    />
                                </FormControl>
                                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                    <DateTimePickerControl
                                        sx={{ flex: 1 }}
                                        id="endDate"
                                        control={control}
                                        label="Bitiş Tarihi"
                                        defaultValue={dayjs()}
                                    />
                                </FormControl>
                                <Button
                                    onClick={handleSubmit(getMerchantGroupedTransactions)}
                                    variant="contained"
                                    text={"ARA"}
                                />
                            </Stack>
                        </Stack>} />
                    <Stack flex={1} mt={2}  >
                        {showTable && (
                            <>
                                <Table
                                    getRowId={() => { return Math.random(100000) }}
                                    isMasterDetailActive={false}
                                    isRowExpandable={false}
                                    columnVisibilityConfigKey="merchantGroupedTransactionsVisibilityKey"
                                    filterKey="merchantGroupedTransactions"
                                    hasActiveFilters={hasActiveFilters}
                                    handleFilterChange={handleFilterChange}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={handleChangePagination}
                                    paginationMode="server"
                                    rowCount={tableData?.totalItems || 0}
                                    isRowSelectable={() => false}
                                    rows={tableData?.result || []}
                                    customLabelDisplayedRows={true}
                                    getRowClassName={(params) => {
                                        if (params.row.merchantStatus === "PASSIVE" || params.row.merchantStatus === "BLOCKED") {
                                            return "merchant-passive-row";
                                        } else {
                                            return '';
                                        }
                                    }}
                                    autoHeight={false}
                                    columns={columns}
                                    exportFileName="İşyeri Başarılı İşlemler"
                                    onSave={() => onExport()}
                                />
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}